import { AppVariables } from "./types";

export const emptyAppVariables: AppVariables = {
  APP_ENV: "",
  AERIALYTIC_API_KEY: "",
  AERIALYTIC_IFRAME_URL: "",
  GOOGLE_ANALYTICS: null,
  NEXT_PUBLIC_RELEASE_NAME: "",
  SENTRY_DSN: "",
  V2_DOMAIN: "",
};
